// extracted by mini-css-extract-plugin
module.exports = {"icon":"Tooltip_icon__2hajI","recordHistoryHelpIcon":"Tooltip_recordHistoryHelpIcon__3Rg4j"};